import React, { useRef, useState, useLayoutEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { Button, Modal, ModalHeader, ModalBody } from 'reactstrap';
import { instance } from '../../common';
import {
  CustomAlert,
  CustomAlert2,
  CustomAlert3,
  CustomAlert_x,
} from './CustomAlert';

const ContractPopup = (props) => {
  const history = useHistory();
  const { toggle, modal, r_id, date, si_id } = props;

  const contractNum = useRef();
  const [promotionText, setText] = useState('계약번호');
  const [popup, setPopup] = useState({
    ok: false,
    no: false,
    ex: false,
    format: false,
    pro: 0,
    co_discount: '',
  });
  const [isSubmitted, setIsSubmitted] = useState(false);

  useLayoutEffect(() => {
    instance.post('/reserve/r_id', { r_id: r_id }).then(function (res) {
      if (res.data[0].s_id) {
        const shop = JSON.parse(res.data[0].s_id)[0];
        if (shop.s_cate === '썬가드하이퍼이벤트' || shop.s_cate === 'BtoB') {
          setText('차대번호');
        }
      }
    });
  }, []);

  const { ok, no, ex, pro, format, co_discount } = popup;
  const submitHandler = () => {
    const inputs = contractNum.current.value;
    console.log('inputs are: ', inputs);
    setIsSubmitted(true);
    // Check out Num
    let isCheck = inputsCheck(inputs);
    if (!isCheck) {
      const session = JSON.parse(window.sessionStorage.result);
      const { u_type } = session;

      let obj = { co_number: inputs, u_type: u_type };
      console.log('obj : ', obj);
      const fetchData = async () => {
        instance.post('/contract/number', obj).then(function (res) {
          if (res.data.msg == 'nodata') {
            setPopup({
              ...popup,
              no: true,
            });
          } else if (res.data.msg == 'exist') {
            setPopup({
              ...popup,
              ex: true,
            });
          } else {
            // console.log('res data rows[0]: ', res);
            let { co_pro, co_discount } = res.data.rows[0];
            updateNum(inputs, co_pro, co_discount, popup, setPopup);
          }
        });
      };

      fetchData();
    } else {
      setPopup({
        ...popup,
        format: true,
      });
    }
  };
  function inputsCheck(inputs) {
    let isCheck = false;
    let check = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/;
    if (check.test(inputs)) {
      isCheck = true;
    }

    if (inputs.length != 13) {
      isCheck = true;
    }
    console.log('isCheck : ', isCheck);
    return isCheck;
  }
  function updateNum(inputs, co_pro, co_discount, popup, setPopup) {
    const session = JSON.parse(window.sessionStorage.result);
    const { u_login_id, u_type } = session;
    let obj;
    if (u_type === '일반고객' || u_type === '총판' || u_type === '클라이언트') {
      obj = { co_user_id: u_login_id };
    } else if (u_type == '카마스터') {
      obj = { co_user_id2: u_login_id, is_use: 1 };
    } else if (u_type == '시공지점') {
      obj = { co_user_id2: u_login_id, is_use: 1 };
    }

    let valueObj = {
      obj: obj,
      whereField: 'co_number',
      whereValue: inputs,
    };

    const fetchData = async () => {
      instance.post('/contract/update', valueObj).then(function (res) {
        if (
          u_type === '일반고객' ||
          u_type === '총판' ||
          u_type === '클라이언트'
        ) {
          if (co_pro === 1) {
            setPopup({
              ...popup,
              ok: true,
              pro: 1,
              co_discount: co_discount,
            });
          } else if (co_pro === 0) {
            setPopup({
              ...popup,
              ok: true,
              pro: 0,
            });
          }
        } else if (u_type == '카마스터' || u_type == '시공지점') {
          if (co_pro == 1) {
            //alert('프로모션 대상 고객 계약번호 입니다.\n결제 단계를 건너뜁니다.');
            setPopup({
              ...popup,
              ok: true,
              pro: 1,
              co_discount: co_discount,
            });
          } else if (co_pro == 0) {
            setPopup({
              ...popup,
              ok: true,
              pro: 0,
            });
          }
          //alert('정상적으로 차량추가가 되었습니다.\n차량정보에서 확인 해보세요.');
        }
      });
    };

    fetchData();
  }

  return (
    <div>
      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle} style={{ borderBottom:"0" }}></ModalHeader>
        <p className="text-center font-weight-bold" style={{ fontSize:"20px" }}> {promotionText} 입력</p>
        <ModalBody style={{ height:"600px", padding:"3rem 8rem" }}>
          <h3 className="font-weight-bold mb-3">
            {promotionText}를 입력해주세요.
          </h3>
          <input ref={contractNum} type="text" name="contract-num" style={{ border:"0px", borderBottom:"1px solid #c4c4c4", paddingTop:"3rem"}}/>
          {!isSubmitted && <p className="c_certify my-3">{promotionText}를 -없이 입력해주세요</p>}
          {ok && (
            <CustomAlert
              history={history}
              pro={pro}
              date={date}
              r_id={r_id}
              si_id={si_id}
              inputs={contractNum.current.value}
              co_discount={co_discount}
              promotionText={promotionText}
            />
          )}
          {no && (
            <CustomAlert2
              onConfirm={setIsSubmitted}
              setPopup={setPopup}
              popup={popup}
              promotionText={promotionText}
            />
          )}
          {ex && (
            <CustomAlert3
              onConfirm={setIsSubmitted}
              setPopup={setPopup}
              popup={popup}
              promotionText={promotionText}
            />
          )}
          {format && (
            <CustomAlert_x
              onConfirm={setIsSubmitted}
              setPopup={setPopup}
              popup={popup}
              promotionText={promotionText}
            />
          )}
          {!isSubmitted && <Button className="w-100 p-3 mt-5" style={{ backgroundColor:"#2F79D9", color:"white" }} color="" onClick={submitHandler}>
            등록
          </Button>}
        </ModalBody>
      </Modal>
    </div>
  );
};

export default ContractPopup;
